import {flags} from "./FlagURL";

export const currencyList:any[]=[
    {
        flag: flags.USD,
        symbol: "USD",
        name: "United States",
    },
    {
        flag: flags.GBP,
        symbol: "GBP",
        name: "European Union",
    },
    {
        flag: flags.CHF,
        symbol: "CHF",
        name: "Switzerland",
    },
    {
        flag: flags.AUD,
        symbol: "AUD",
        name: "Australia",
    },
    {
        flag: flags.JPY,
        symbol: "JPY",
        name: "Japan",
    },
    {
        flag: flags.MYR,
        symbol: "MYR",
        name: "Malaysia",
    },
    {
        flag: flags.SGD,
        symbol: "SGD",
        name: "Singapore",
    },
    {
        flag: flags.HKD,
        symbol: "HKD",
        name: "Hong Kong",
    },
    {
        flag: flags.CAD,
        symbol: "CAD",
        name: "Canada",
    },
    {
        flag: flags.DKK,
        symbol: "DKK",
        name: "Denmark",
    },
    {
        flag: flags.NOK,
        symbol: "NOK",
        name: "Norway",
    },
    {
        flag: flags.SEK,
        symbol: "SEK",
        name: "Sweden",
    },
    {
        flag: flags.TWD,
        symbol: "TWD",
        name: "Taiwan",
    },
    {
        flag: flags.KRW,
        symbol: "KRW",
        name: "Korea",
    },
    {
        flag: flags.CNY,
        symbol: "CNY",
        name: "China",
    },
    {
        flag: flags.PHP,
        symbol: "PHP",
        name: "Phillippines",
    },
    {
        flag: flags.NZD,
        symbol: "NZD",
        name: "New Zealand",
    },
    {
        flag: flags.SAR,
        symbol: "SAR",
        name: "Saudi Arabia",
    },
    {
        flag: flags.AED,
        symbol: "AED",
        name: "United Arab Emirates",
    },
    {
        flag: flags.QAR,
        symbol: "QAR",
        name: "Qatar",
    },
    {
        flag: flags.OMR,
        symbol: "OMR",
        name: "Oman",
    },
    {
        flag: flags.BHD,
        symbol: "BHD",
        name: "Bahrain",
    },
    {
        flag: flags.VND,
        symbol: "VND",
        name: "Vietnam",
    },
    {
        flag: flags.BND,
        symbol: "BND",
        name: "Brunei",
    },
    {
        flag: flags.KWD,
        symbol: "KWD",
        name: "Kuwait",
    },
    {
        flag: flags.ZAR,
        symbol: "ZAR",
        name: "South Africa",
    },
    {
        flag: flags.IDR,
        symbol: "IDR",
        name: "Indonesia",
    },
    {
        flag: flags.INR,
        symbol: "INR",
        name: "India",
    },
    {
        flag: flags.SCOT,
        symbol: "SCOT",
        name: "Scotland",
    },
    {
        flag: flags.RUB,
        symbol: "RUB",
        name: "Russia",
    },
    {
        flag: flags.TRY,
        symbol: "TRY",
        name: "Turkey",
    },
    {
        flag: flags.MMK,
        symbol: "MMK",
        name: "Myanmar",
    },
    {
        flag: flags.LAK,
        symbol: "LAK",
        name: "Laos",
    },
    {
        flag: flags.THB,
        symbol: "THB",
        name: "Thailand",
    },
]